export default __webpack_public_path__ + "static/media/locked.997584e7.svg";